import admin from "../middleware/admin";
import auth from "../middleware/auth";
import requiresPasswordChange from "../middleware/user-password-change";

export default {
  path: "kategorijas-sabloni",
  name: "view-template-categories",
  meta: {
    middleware: [auth, admin, requiresPasswordChange]
  },
  component: () => import("@/components/categories/TemplateCategories"),
};
